import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/product';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-4 py-6 sm:py-8" data-id="element-32" data-mp="1hd1pg3r03i25">
      <div className="mx-auto max-w-3xl" data-id="element-33" data-mp="1hdupklvgf9bb">
        <h2 className="text-center text-2xl text-navy sm:text-4xl" data-id="element-34" data-mp="1cf057fhu9cp3">
          FREQUENTLY ASKED QUESTIONS
        </h2>

        <ul className="mt-4 divide-y divide-navy/10 overflow-hidden rounded-xl border border-navy/10 bg-white" data-id="element-35" data-mp="2a1788kyhuwzc">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} data-id="element-36" data-mp="202hosnqy94gz" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition-colors duration-150 hover:bg-paper" data-id="element-37" data-mp="205vv272qhxtp">
                  <span className="font-display text-lg uppercase leading-tight text-navy" data-id="element-38" data-mp="1kn6zzz3hupnc">
                    {faq.q}
                  </span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-auto" aria-hidden="true" data-id="element-39" data-mp="1pkguvu9njtik" /> : <PlusIcon className="h-5 w-5 shrink-0 text-auto" aria-hidden="true" data-id="element-40" data-mp="1fmst4kdmplqw" />}
                </button>
                {isOpen && <p className="px-4 pb-3 text-sm font-medium leading-snug text-ink/80" data-id="element-41" data-mp="rz2v3fsqyglp">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}